import React, { FC, ReactNode, MouseEvent } from 'react';
import { Button as MButton } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  onClick?: (e?: MouseEvent<HTMLButtonElement>) => void;
  fullWidth?: boolean;
  small?: boolean;
  color?: 'burgundy' | 'dark-green' | 'gray' | 'gray-light';
  className?: string;
  id?: string;
  children: ReactNode;
  type?: 'button' | 'submit';
  disabled?: boolean;
  ariaLabel?: string;
  loading?: boolean;
  buttonStyle?: {
    [key: string]: string;
  };
  mobileFullWidth?: boolean;
  onMouseEnter?: (()=>void) | undefined;
  onMouseLeave?: (()=>void) | undefined;
}

const Button: FC<Props> = ({
  children,
  onClick,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
  fullWidth,
  className,
  id,
  small,
  color = 'burgundy',
  type = 'button',
  disabled = false,
  ariaLabel,
  loading,
  buttonStyle,
  mobileFullWidth,
  ...others
}: Props): JSX.Element => {
  return (
    <MButton
      onMouseEnter={onMouseEnter}
      onMouseLeave= {onMouseLeave}
      type={type}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      style={buttonStyle}
      id={id}
      className={classNames(styles.button, className, {
        [styles['small']]: small,
        [styles['full_width']]: fullWidth,
        [styles[`btn_color_${color}`]]: color,
        [styles['mobile_full_width']]: mobileFullWidth,
      })}
      aria-label={ariaLabel}
      {...others}>
      {children}
    </MButton>
  );
};

export default Button;
